import inspectorAncillaryServiceActionTypes from '../actionTypes'

const initialState = {
  datatable: {
    data: [],
    total: 1
  }
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case inspectorAncillaryServiceActionTypes.GET_INSPECTOR_ANCILLARY_SERVICE_DATATABLE:
      return {
        ...state,
        datatable: {
          data: payload?.data,
          total: payload?.totalPages,
          params: payload?.params
        }
      }
    default:
      return state
  }
}
